const checkIfCorrectTimeModalContent = () =>{
    const modal = document.getElementById('myHelpModal');
    if(modal){
        let current = modal.getAttribute('data-current');

        let start = modal.getAttribute('data-start');

        let end = modal.getAttribute('data-end');

        let during = modal.getAttribute('data-during');
        let nextDay = modal.getAttribute('data-next-day');
        let active = modal.querySelector('.csp-help-modal-rotate-content');
        let backup = modal.querySelector('.csp-help-modal-rotate-backup');
        let today = new Date();
        let now = today.getHours().toString().padStart(2, '0') + today.getMinutes().toString();
        let day = today.getDay();
        let isDuring = false;
        if(current !== null && current !== undefined){
            if(nextDay === 'next'){
                if(start <= now && now > end){
                    isDuring = true;
                }
                if(start > now && now < end){
                    isDuring = true;
                }
            }
            if(nextDay === 'same'){
                if(start <= now && now <= end){
                    isDuring = true;
                }
            }
            if(day === 0 || day === 6){
                isDuring = true;
            }

            if(isDuring && during !== 'during'){
                active.classList.add('d-none');
                backup.classList.remove('d-none');

            }
            if(!isDuring && during === 'during'){
                active.classList.add('d-none');
                backup.classList.remove('d-none');

            }
        }

    }
}
export default checkIfCorrectTimeModalContent;